import { Breadcrumb, Input } from "antd";
import React, { useEffect } from "react";

import { useListUser } from "../../../hooks/api/user-table/hooks";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import UserTableList from "./UserTable";
import { parseAsString, useQueryStates } from "nuqs";

interface Props {
  allowURLStateUpdate?: boolean;
}

const UserTable: React.FC<Props> = ({ allowURLStateUpdate = true }) => {
  const [breadcrumb] = React.useState("Users");
  const navigate = useNavigate();

  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  // --- FIX HERE ---
  const [{ key: searchValue }, setSearchQuery] = useQueryStates(
    { key: parseAsString.withDefault("") },
    DEFAULT_NUQS_CONFIG
  );

  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useListUser({
    page: 1,
    limit: 10,
    name: searchValue || undefined,
  });

  const qData = data?.qData ?? { page: 1, limit: 10 };

  useEffect(() => {
    const timeout = setTimeout(() => {
      refetch({
        page: 1,
        limit: qData.limit,
        key: searchValue || undefined,
      });
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchValue]);

  return (
    <div>
      <div className="mb-6">
        <div className="flex justify-between md:flex-row flex-col w-full">
          <div>
            <h1 className="text-lg sm:text-3xl font-semibold sm:mb-1">
              User Management
            </h1>
            <div className="mb-4 flex w-full justify-between">
              <Breadcrumb
                separator=">"
                items={[{ title: "Dashboard" }, { title: breadcrumb }]}
              />
            </div>
          </div>

          <div className="flex justify-end mb-3">
            <Input
              placeholder="Search user"
              allowClear
              value={searchValue ?? ""}
              onChange={(e) => setSearchQuery({ key: e.target.value })}
              prefix={<Search size={18} className="text-gray-500" />}
              className="w-full md:max-w-[350px] cursor-pointer bg-[#FEF2E7]  h-[40px] rounded-lg"
            />
          </div>
        </div>

        <UserTableList
          qData={qData}
          refetch={refetch}
          isFetching={isFetching}
          data={data?.data || []}
          allowURLStateUpdate={allowURLStateUpdate}
          DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG}
        />
      </div>
    </div>
  );
};

export default UserTable;
